<img class="preview" *ngIf="preview$ | async as preview" [src]="preview" [alt]="alt">
